import { Slider } from 'antd'
import React from 'react'

import './CustomSlider.css'

const CustomSlider = ({
  value = 50,
  min = 0,
  max = 100,
  hideHandle = false,
  hideMarks = false,
  disabled = false,
  onChange = null,
  displayTooltip = false,
  tooltip = null,
}) => {
  const calcValueIfMaxedOut = num => {
    // If value is at max, adjust the num to avoid overlapping since objects don’t allow duplicate keys
    return value === max ? num + 1 : num
  }
  const marks = {
    [value]: <div className="slider-edge-text left">${value}</div>,
    [calcValueIfMaxedOut(max)]: (
      <div className="slider-edge-text left">${max}</div>
    ),
  }

  return (
    <div className={`custom-slider ${hideHandle ? 'hide-handle' : ''}`}>
      <Slider
        value={calcValueIfMaxedOut(value)}
        min={min}
        max={calcValueIfMaxedOut(max)}
        defaultValue={[min, max]}
        marks={hideMarks ? null : marks}
        onChange={onChange}
        included={true}
        disabled={disabled}
        tooltip={displayTooltip ? tooltip : null}
      />
    </div>
  )
}

export default CustomSlider
